import { permissionKeys } from '@pm/contracts';
import { z } from 'zod';

const sessionSchema = z.object({
  authenticated: z.boolean(),
  user: z
    .object({
      id: z.string(),
      email: z.string(),
      displayName: z.string(),
    })
    .nullable(),
  access: z.object({
    global: z.array(z.enum(permissionKeys)),
    anyScope: z.array(z.enum(permissionKeys)),
    roleNames: z.array(z.string()),
    isAdmin: z.boolean().optional(),
  }),
  googleConfigured: z.boolean(),
  features: z
    .object({
      capacity: z.boolean(),
      insights: z.boolean(),
      finance: z.boolean(),
      agent: z.boolean(),
    })
    .default({ capacity: true, insights: true, finance: true, agent: false }),
});

export const sessionResponseSchema = sessionSchema;
export const csrfResponseSchema = z.object({ csrfToken: z.string().min(1) });

export type Session = z.infer<typeof sessionSchema>;
